module.exports = __webpack_public_path__ + "static/media/Hotel-Room-Generic.d25d6610.jpg";